<div class="card border-0" style="background-color: #b2d0dc" *transloco="let t; read: 'ime.components.dashboard'">
  <div class="card-body">
    <h4 class="card-title pb-3">
      <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#magnifying-glass'">
      </svg>
      {{t('Saved filters')}}
      <help-button *transloco="let h" [key]="h('help.ime.components.dashboard.saved-filters')"/>
    </h4>
    <ng-container *ngIf="hasSavedFilters || hasSharedFilters; else noFiltersTemplate">
      <ul class="list-group list-group-flush border-bottom">
        <ng-container *ngIf="hasSharedFilters">
          <li class="list-group-item d-flex justify-content-between parent" *ngFor="let filter of sharedFilters">
            <ng-container [ngTemplateOutlet]="editableFilter?.Id === filter.Id ? editSharedTemplate : viewTemplate" [ngTemplateOutletContext]="{filter: filter, isShared: true}"></ng-container>
            <ng-template #editSharedTemplate>
              <div class="input-group">
                <input type="text" class="form-control" [(ngModel)]="editableFilter.Name" (keydown.enter)="saveShared()" name="name-{{editableFilter.Id}}" id="name-{{editableFilter.Id}}" placeholder="{{t('Name')}}">
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteShared()" title="Delete">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#trash'"></svg>
                </button>
                <button type="button" class="btn btn-sm btn-outline-warning" (click)="cancel()" title="Cancel">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#x-mark'"></svg>
                </button>
                <button type="button" class="btn btn-sm btn-outline-success" (click)="saveShared()" title="Save">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#check'"></svg>
                </button>
              </div>
            </ng-template>
          </li>
        </ng-container>
      </ul>
      <ul class="list-group list-group-flush">
        <ng-container *ngIf="hasSavedFilters">
          <li class="list-group-item d-flex justify-content-between parent" *ngFor="let filter of savedFilters">
            <ng-container [ngTemplateOutlet]="editableFilter?.Id === filter.Id ? editTemplate : viewTemplate" [ngTemplateOutletContext]="{filter: filter}"></ng-container>
            <ng-template #editTemplate>
              <div class="input-group">
                <input type="text" class="form-control" [(ngModel)]="editableFilter.Name" (keydown.enter)="save()" name="name-{{editableFilter.Id}}" id="name-{{editableFilter.Id}}" placeholder="{{t('Name')}}">
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete()" title="Delete">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#trash'"></svg>
                </button>
                <button type="button" class="btn btn-sm btn-outline-warning" (click)="cancel()" title="Cancel">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#x-mark'"></svg>
                </button>
                <button type="button" class="btn btn-sm btn-outline-success" (click)="save()" title="Save">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#check'"></svg>
                </button>
                <button type="button" class="btn btn-sm btn-outline-success" (click)="share()" title="Share: make filter visible for all users">
                  <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#share'"></svg>
                </button>
              </div>
            </ng-template>
          </li>
        </ng-container>
      </ul>
    </ng-container>
    <ng-template #viewTemplate let-filter="filter" let-isShared="isShared">
      <div class="d-flex justify-content-start">
        <div class="badge bg-dark me-2 fs-3" *ngIf="isShared">
          Shared
        </div>
        <a href="javascript:void(0)" (click)="open(filter)">{{filter.Name}}</a>
      </div>
      <button type="button" class="btn btn-sm btn-outline-primary show-on-parent-hover my-n1" (click)="edit(filter)" title="Edit">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      </button>
    </ng-template>
    <ng-template #noFiltersTemplate>
      <ul class="list-group list-group-flush">
        <li class="list-group-item d-flex justify-content-between">
          {{t('No saved filters')}}
        </li>
      </ul>
    </ng-template>
  </div>
</div>
